export const getLabel = (diccionario, label, idioma) => {
    try{
      return diccionario[label][idioma] || label;
    }
    catch{
      return label;
    }
  }